import { Suspense } from "react";
import SuccessPage from "@/app/booking/success/success";

export default function BookingSuccessPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SuccessPage />
    </Suspense>
  )
}
